/**
 * Ícone e cor de cada rede, num lugar só — calendário, composer, contas,
 * insights e captação mostram as mesmas cinco redes.
 */

import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import type { SocialNetwork } from "@shared/social-publishing";

/** O lucide não tem o TikTok: a nota musical do logo, traço simples. */
function TikTok({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5" />
      <path d="M14 3c.4 2.6 2.2 4.4 5 4.6" />
    </svg>
  );
}

export const COR_DA_REDE: Record<SocialNetwork, string> = {
  instagram: "text-pink-600",
  facebook: "text-blue-600",
  tiktok: "text-foreground",
  youtube: "text-red-600",
  linkedin: "text-sky-700",
};

export function IconeRede({ rede, className = "h-4 w-4", colorido = true }: { rede: SocialNetwork | string; className?: string; colorido?: boolean }) {
  const cor = colorido ? (COR_DA_REDE[rede as SocialNetwork] ?? "") : "";
  const cls = `${className} ${cor}`.trim();
  switch (rede) {
    case "instagram":
      return <Instagram className={cls} />;
    case "facebook":
      return <Facebook className={cls} />;
    case "tiktok":
      return <TikTok className={cls} />;
    case "youtube":
      return <Youtube className={cls} />;
    case "linkedin":
      return <Linkedin className={cls} />;
    default:
      return null;
  }
}
